import {
  LeftOutlineIcon,
  RestartIcon,
  RightOutlineIcon,
} from '@carboncopyco/icons';
import { Button, TooltipBubble } from '@carboncopyco/ui';
import type { NavigationMenuProps } from './NavigationMenu';

type NavigationControls = Omit<NavigationMenuProps, 'tourSettings'>;

export const NavigationControls = ({
  stepCount,
  isTourFirstStep,
  isTourLastStep,
  onNextClick,
  onBackClick,
  onRestartClick,
}: NavigationControls) => {
  return (
    <>
      <div className="flex items-center p-2 bg-ds-natural-600 bg-opacity-90 rounded-tl-lg">
        <TooltipBubble
          appendTo={'parent'}
          placement="top"
          title="Previous"
          offset={[0, 10]}
          disabled={isTourFirstStep}
          interactive
        >
          <Button
            disabled={isTourFirstStep}
            onClick={onBackClick}
            icon={<LeftOutlineIcon />}
            linkDark
          />
        </TooltipBubble>
        <div className="flex justify-center w-16 text-ds-accent3-100 text-sm">
          {stepCount.current} / {stepCount.total}
        </div>
        <TooltipBubble
          appendTo={'parent'}
          placement="top"
          title="Next"
          offset={[0, 10]}
          disabled={isTourLastStep}
          interactive
        >
          <Button
            disabled={isTourLastStep}
            onClick={onNextClick}
            icon={<RightOutlineIcon />}
            linkDark
          />
        </TooltipBubble>
      </div>
      <div className="flex items-center ml-0.5 px-3 py-2 bg-ds-natural-600 bg-opacity-90 !text-sm">
        <Button
          label="Restart"
          onClick={onRestartClick}
          xSmall
          leftIcon={<RestartIcon size={16} />}
          linkDark
        />
      </div>
    </>
  );
};
